import React from "react";
import "./IndividualOrderPage.css";
import smallCircleHeartImg from "../assets/images/smallCircleHeartImg.png";
import smallStarImg from "../assets/images/smallStarImg.png";
import smallLeafImg from "../assets/images/smallLeafImg.png";
import coloredHeartImg from "../assets/images/coloredHeartImg.png";
import coloredMessageImg from "../assets/images/coloredMessageImg.png";
import coloredPencilImg from "../assets/images/coloredPencilImg.png";
import dottedArrowImg from "../assets/images/dottedArrowImg.png";
import circleInstagramImg from "../assets/images/circleInstagramImg.png";
import circleMessengerImg from "../assets/images/circleMessengerImg.png";
import letterImg from "../assets/images/letterImg.png";
import SEO from "../components/SEO";
import individualOrderImg from "../assets/images/individualOrderImg.png"
const STEPS = [
  {
    n: "1",
    image: coloredMessageImg,
    title: "Зв'яжіться з нами",
    desc: "Розкажіть про свою ідею, побажання та розміри.",
  },
  {
    n: "2",
    image: coloredPencilImg,
    title: "Узгодження деталей",
    desc: "Ми підготуємо макет та погодимо його з вами.",
  },
  {
    n: "3",
    image: coloredHeartImg,
    title: "Виготовлення",
    desc: "Друкуємо з любов'ю та доставляємо ваше замовлення.",
  },
];

const CONTACTS = [
  {
    image: circleInstagramImg,
    label: "Instagram",
    value: "@zori.place.stickers",
    action: "Написати в Direct",
    href: "https://www.instagram.com/zori.place.stickers",
  },
  {
    image: letterImg,
    label: "Email",
    value: "zori.place1@gmail.com",
    action: "Написати листа",
    href: "mailto:zori.place1@gmail.com",
  },
  {
    image: circleMessengerImg,
    label: "Messenger",
    value: "+380933406560",
    action: "Написати",
    href: "tel:+380933406560",
  },
];

export default function IndividualOrderPage() {
  return (
    <div className="indiv-page page-enter">
      <SEO
        title="Індивідуальне замовлення"
        description="Мрієте про особливий декор, якого ніде немає? Ми із задоволенням допоможемо втілити вашу ідею в реальність. Зв'яжіться з нами, ми підготуємо макет та погодимо його з вами."
        url="https://zori.place/individual-order"
      />
      {/* Breadcrumb */}
      <div className="container indiv-breadcrumb">
        <a href="/">Головна</a>
        <span>›</span>
        <span>Індивідуальне замовлення</span>
      </div>

      {/* Hero */}
      <section className="indiv-hero">
<img src={individualOrderImg} alt="Individual order" fetchpriority="high" decoding="async" className="hero-bg" />
        <div className="container indiv-hero-inner">
          <div className="indiv-hero-content">
            <h1 className="indiv-hero-title">Індивідуальне замовлення</h1>
            <p className="indiv-hero-desc">
              Мрієте про особливий декор, якого ніде немає? Ми із задоволенням допоможемо втілити
              вашу ідею в реальність.
            </p>
            <div className="indiv-features">
              <div className="indiv-feature">
                <img src={smallCircleHeartImg} alt="small heart" />
                <span>Унікальний дизайн під ваш простір</span>
              </div>
              <div className="indiv-feature">
                <img src={smallStarImg} alt="small star" />
                <span>Будь-який розмір та кольорова гама</span>
              </div>
              <div className="indiv-feature">
                <img src={smallLeafImg} alt="small leaf" />
                <span>Якісні матеріали та друк</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How to order */}
      <section className="indiv-how">
        <div className="container">
          <h2 className="section-title">Як зробити індивідуальне замовлення?</h2>
          <div className="indiv-steps">
            {STEPS.map((s, i) => (
              <React.Fragment key={s.n}>
                <div className="indiv-step">
                  <div className="indiv-step-circle">
                    <img src={s.image} alt={s.title} />
                  </div>
                  <p className="indiv-step-label">
                    {s.n}. {s.title}
                  </p>
                  <p className="indiv-step-desc">{s.desc}</p>
                </div>
                {i < STEPS.length - 1 && (
                  <div className="indiv-step-arrow">
                    <img src={dottedArrowImg} alt="arrow" />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* Contact options */}
      <section className="indiv-contact">
        <div className="container">
          <h2 className="section-title">Зв'яжіться з нами зручним способом</h2>
          <div className="indiv-contacts-grid">
            {CONTACTS.map((c) => (
              <div key={c.label} className="indiv-contact-card">
                <div className="indiv-contact-icon">
                  <img src={c.image} alt={c.label} />
                </div>
                <strong>{c.label}</strong>
                <p>{c.value}</p>
                <a
                  href={c.href}
                  target="_blank"
                  rel="noreferrer"
                  className={`indiv-contact-btn ${c.label}`}
                >
                  {c.action}
                </a>
              </div>
            ))}
          </div>
          <p className="indiv-note">Ми відповідаємо швидко та з радістю допоможемо вам! ✦</p>
        </div>
      </section>
    </div>
  );
}
